import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';

const ImageContainer = styled.div`
  img {
    height: 93px;
    vertical-align: middle;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    img {
      height: 47px;
    }
  }
`;
interface ItemImageProps {
  image: string;
}

const ItemImage: React.FC<ItemImageProps> = ({ image}) => {
  return (
    <ImageContainer>
      <img src={image} />
    </ImageContainer>
  );
};

export default ItemImage;